import { useEffect, useRef, useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const lastScrollYRef = useRef(0);


  const handleRequestClick = () => {
    if (typeof window === 'undefined') return;

    const el = document.querySelector('#kontakt');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
      return;
    }

    window.location.href = '/#kontakt';
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleScroll = () => {
      if (typeof window === 'undefined') return;

      const currentY = window.scrollY || window.pageYOffset;
      const lastY = lastScrollYRef.current;

      const THRESHOLD = 16;

      if (Math.abs(currentY - lastY) < THRESHOLD) {
        return;
      }

      if (currentY > lastY && currentY > 80) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }

      lastScrollYRef.current = currentY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const linkClasses =
    'relative text-[0.7rem] lg:text-[0.74rem] font-semibold tracking-[0.16em] uppercase text-[#0F172A] hover:text-[#027FDB] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-full after:scale-x-0 after:bg-[#027FDB] after:origin-center after:transition-transform after:duration-200 hover:after:scale-x-100';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-white/92 md:bg-white/88 backdrop-blur-xl border-b border-[#E6EEF5] shadow-[0_8px_24px_rgba(15,23,42,0.035)] transform transition-all duration-300 ${
        isHidden ? '-translate-y-full' : 'translate-y-0'
      }`}
    >

      {/* MAIN ROW */}
      <div className="max-w-[76rem] mx-auto px-4 md:px-6 py-3.5 md:py-4 flex items-center gap-3 md:gap-4">
        {/* LEFT — LOGO */}
        <a href="/#hero" className="cursor-pointer flex items-center gap-2.5 md:gap-3 shrink-0">
          <img src="/images/logo.png" alt="Alltagsstern Logo" className="h-[2.35rem] md:h-[2.55rem] lg:h-[2.8rem] w-auto" />
          <span
            className="text-[1.35rem] md:text-[1.65rem] lg:text-[1.85rem] font-bold tracking-[0.03em] uppercase text-[#027FDB] leading-none"
            style={{
              fontFamily:
                'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            }}
          >
            Alltagsstern
          </span>
        </a>

        {/* DESKTOP NAV (ONEPAGER ANCHORS) */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-8 ml-auto">
          <a
            href="/#hero"
            className={linkClasses}
            style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
          >
            Start
          </a>
          <a
            href="/#services"
            className={linkClasses}
            style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
          >
            Leistungen
          </a>
          <a
            href="/#process-section"
            className={linkClasses}
            style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
          >
            Ablauf
          </a>
          <a
            href="/#about"
            className={linkClasses}
            style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
          >
            Über uns
          </a>
          <a
            href="/#kontakt"
            className={linkClasses}
            style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
          >
            Kontakt
          </a>
        </nav>

        <button
          type="button"
          onClick={handleRequestClick}
          className="hidden md:inline-flex ml-5 h-11 lg:h-12 px-6 lg:px-7 items-center justify-center gap-2.5 rounded-full bg-[linear-gradient(135deg,#027FDB,#027FDB,#38A9FF)] border border-[#9BD7FF] text-white text-[0.7rem] lg:text-[0.74rem] font-semibold tracking-[0.12em] uppercase shadow-[0_12px_28px_rgba(2,127,219,0.16)] hover:translate-y-[-1px] hover:shadow-[0_16px_34px_rgba(2,127,219,0.22)] transition-all duration-300"
          style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
        >
          <i className="ri-send-plane-fill text-sm lg:text-base" aria-hidden="true" />
          Erstberatung anfragen
        </button>

        {/* MOBILE MENU TOGGLE + CTA */}
        <div className="md:hidden flex items-center justify-end gap-2 ml-auto">
          <button
            type="button"
            onClick={handleRequestClick}
            aria-label="Unverbindliche Erstberatung anfragen"
            className="inline-flex h-11 min-w-[12.4rem] px-5 items-center justify-center gap-2 rounded-full whitespace-nowrap bg-[linear-gradient(135deg,#027FDB,#027FDB,#38A9FF)] border border-[#9BD7FF] text-white text-[0.62rem] font-semibold tracking-[0.06em] uppercase shadow-[0_10px_24px_rgba(2,127,219,0.16)] hover:shadow-[0_14px_30px_rgba(2,127,219,0.22)] transition-all duration-300"
            style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}
          >
            <i className="ri-send-plane-fill text-sm" aria-hidden="true" />
            Erstberatung
          </button>
          <button
            className="w-10 h-10 flex items-center justify-center bg-white border border-[#E6EEF5] shadow-[0_8px_20px_rgba(15,23,42,0.04)] hover:bg-[#F3F9FF] rounded-full transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-label="Menü"
          >
            <span className="relative flex h-5 w-7 items-center justify-center">
              <span
                className={`absolute h-[2px] w-7 rounded-full bg-[#0F172A] transition-transform duration-300 ${
                  isMenuOpen ? 'translate-y-0 rotate-45' : '-translate-y-1.5 rotate-0'
                }`}
              />
              <span
                className={`absolute h-[2px] w-7 rounded-full bg-[#0F172A] transition-opacity duration-300 ${
                  isMenuOpen ? 'opacity-0' : 'opacity-100'
                }`}
              />
              <span
                className={`absolute h-[2px] w-7 rounded-full bg-[#0F172A] transition-transform duration-300 ${
                  isMenuOpen ? 'translate-y-0 -rotate-45' : 'translate-y-1.5 rotate-0'
                }`}
              />
            </span>
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`md:hidden border-t border-[#E6EEF5] px-6 overflow-hidden transform transition-all duration-300 ease-out ${
          isMenuOpen
            ? 'bg-[linear-gradient(180deg,rgba(255,255,255,0.985),rgba(248,250,252,0.985),rgba(243,249,255,0.985))] backdrop-blur-xl py-5 opacity-100 max-h-[30rem]'
            : 'bg-transparent backdrop-blur-0 py-0 opacity-0 max-h-0'
        }`}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col space-y-4">
            <a
              href="/#hero"
              className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase"
              style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: '#0F172A' }}
              onClick={() => setIsMenuOpen(false)}
            >
              Start
            </a>
            <a
              href="/#services"
              className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase"
              style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: '#0F172A' }}
              onClick={() => setIsMenuOpen(false)}
            >
              Leistungen
            </a>
            <a
              href="/#process-section"
              className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase"
              style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: '#0F172A' }}
              onClick={() => setIsMenuOpen(false)}
            >
              Ablauf
            </a>
            <a
              href="/#about"
              className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase"
              style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: '#0F172A' }}
              onClick={() => setIsMenuOpen(false)}
            >
              Über uns
            </a>
            <a
              href="/#kontakt"
              className="text-[0.72rem] font-semibold tracking-[0.18em] uppercase"
              style={{ fontFamily: 'Manrope, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: '#0F172A' }}
              onClick={() => setIsMenuOpen(false)}
            >
              Kontakt
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
